import { useState } from 'react';
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { handleRequest, sortAlphabetically } from '~/infra/utils';
import { relationshipSummaryModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
const SIGNED_AGREEMENT_STATUSES = new Set([
    'approved',
    'terminated'
]);
const mapRelationshipSummariesToAgreementOptions = (relationshipSummaries)=>{
    const options = relationshipSummaries.map((summary)=>({
            label: summary.title,
            value: summary.id
        }));
    return sortAlphabetically(options, 'label', {
        ascending: true,
        ignoreCase: true
    });
};
export const defaultAgreementStatusSelectorFilter = [
    relationshipSummaryModel.AgreementStatus.Active,
    relationshipSummaryModel.AgreementStatus.Exhausted
];
export const useFetchContactAgreements = ()=>{
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    const { t: texts } = useLocaleKeys('components.globalBillModal');
    const businessId = useStore(selectors.user.businessId);
    const isVendor = useStore(selectors.user.isVendor);
    const [agreements, setAgreements] = useState([]);
    const [adHocSummary, setAdHocSummary] = useState(null);
    const [loading, setLoading] = useState(false);
    const fetchAgreements = async (clientContactId)=>{
        if (!businessId) {
            return;
        }
        setLoading(true);
        const response = await handleRequest(api.relationship.getSummaries({
            businessId,
            isVendor,
            clientContactId,
            type: 'agreementAndAdHoc'
        }));
        setLoading(false);
        if (response.success) {
            var _response_data_find;
            const isSignedAgreement = (s)=>SIGNED_AGREEMENT_STATUSES.has(s.status);
            const adHoc = (_response_data_find = response.data.find((s)=>!isSignedAgreement(s))) !== null && _response_data_find !== void 0 ? _response_data_find : null;
            const signed = response.data.filter((s)=>isSignedAgreement(s) && s.agreementStatusV2 != null && defaultAgreementStatusSelectorFilter.includes(s.agreementStatusV2));
            setAdHocSummary(adHoc);
            const newAgreements = mapRelationshipSummariesToAgreementOptions(signed);
            setAgreements(newAgreements);
            return {
                agreements: newAgreements,
                hasAdHoc: adHoc != null
            };
        } else {
            overlayContext.showErrorToast(texts.failedToLoadAgreements(), 'agreements-request-error-toast');
        }
    };
    const resetAgreements = ()=>{
        setAgreements([]);
        setAdHocSummary(null);
    };
    return {
        fetchAgreements,
        resetAgreements,
        agreements,
        adHocSummary,
        loading,
        isOnlyOneAgreement: agreements.length === 1
    };
};
